export class ServerErrorHandler {
    constructor(error) {
        this.error = error
    }

    getMessage(defaultMessage) {

        if (this.error.response && this.error.response.data.message) {
            return this.error.response.data.message
        } else if (this.error.response && this.error.response.status === 500) {
            return `خطای ۵۰۰، لطفا با پشتیبانی تماس حاصل فرمایید.`
        } else {
            return defaultMessage
        }
    }

    getStatusCode() {
        if (this.error.response && this.error.response.data.status) {
            return this.error.response.data.status
        } else if (this.error.response && this.error.response.status === 500) {
            return 500
        } else {
            return -1
        }
    }

}